import { BOOptionModel } from "../data-model/boOptionModel";
import {
  AllCommentsProps,
  BusniessOfficeNote,
} from "../data-model/busniessOfficeNote";
import { BusniessOfficeReportType } from "../enums/busniessOfficeReportType";

export function getLowestPriorityOption(
  options: BOOptionModel[],
  values: string[],
): BOOptionModel | undefined {
  const filtered = options.filter(
    (opt) => values.includes(opt.value) && opt.priority !== undefined,
  );

  if (filtered.length === 0) {
    return options.find((opt) => opt.value === "Required"); // no match
  }

  return filtered.reduce((lowest, current) =>
    current.priority! < lowest.priority! ? current : lowest,
  );
}

/**
 * Pure function that computes the global BO value from comments and BO options.
 * - Single comment: uses that comment's boStatus directly
 * - Multiple comments: picks the lowest priority number (highest priority) from boOptions
 */
export function computeGlobalBoValue(
  allCommentsForUI: AllCommentsProps[],
  boOptions: BOOptionModel[],
): string {
  const finalComments = allCommentsForUI.filter(
    (comment) => comment.type === BusniessOfficeReportType.FINAL,
  );

  if (finalComments.length !== 1) {
    return "";
  }

  const comments = finalComments[0].comments;
  if (comments.length === 1) {
    return comments[0].boStatus || "";
  }

  if (comments.length > 1) {
    const allBoStatuses = comments.map((comment) => comment?.boStatus ?? "");
    const lowestPriorityOption = getLowestPriorityOption(
      boOptions,
      allBoStatuses,
    );
    return lowestPriorityOption?.value || "";
  }

  return "";
}

export const checkIfBusinessOfficeNotesAreEmpty = (
  notes?: BusniessOfficeNote[],
) => {
  return notes === undefined || notes?.length === 0;
};
